import { useSelector } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import {
  getLineColorFunctionMapping,
  getLineWidthFunctionMapping,
  getFillColorFunctionMapping,
  getPointRadiusFunctionMapping,
} from 'components/contexts/LayerStyleReferenceMapping';
import { useAppState } from 'components/contexts/State';
import {
  getFormattedValue,
  getNameFormatterFromColumn,
  getValueFormatterFromColumn,
} from 'components/contexts/ColumnFormatterMapping';

export const CUSTOMSQL_FIFTH_LAYER_ID = 'customSqlFifthLayer';

function CustomSqlFifthLayer() {
  const { customSqlFifthLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, customSqlFifthLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  const { customSqlData } = useAppState();

  if (customSqlFifthLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: CUSTOMSQL_FIFTH_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: customSqlFifthLayer.visible,
      opacity: customSqlFifthLayer.opacity,

      getFillColor: getFillColorFunctionMapping[customSqlFifthLayer.getFillColor]
        ? getFillColorFunctionMapping[customSqlFifthLayer.getFillColor]
        : [0, 0, 0],
      pointRadiusMinPixels: customSqlFifthLayer.pointRadiusMinPixels
        ? customSqlFifthLayer.pointRadiusMinPixels
        : 1,
      getPointRadius: (v) => {
        if (
          customSqlFifthLayer.getFillColor === 'default_point' ||
          customSqlFifthLayer.getFillColor === 'secondary_point' ||
          customSqlFifthLayer.getFillColor === 'tertiary_point'
        )
          return getPointRadiusFunctionMapping.default_point(v);
        return 5;
      },

      getLineColor: getLineColorFunctionMapping[customSqlFifthLayer.getLineColor]
        ? getLineColorFunctionMapping[customSqlFifthLayer.getLineColor]
        : [0, 0, 0],
      lineWidthMinPixels: customSqlFifthLayer.lineWidthMinPixels
        ? customSqlFifthLayer.lineWidthMinPixels
        : 1,
      getLineWidth: (v) => {
        if (
          customSqlFifthLayer.getLineColor === 'default_line' ||
          customSqlFifthLayer.getLineColor === 'secondary_line' ||
          customSqlFifthLayer.getLineColor === 'tertiary_line'
        )
          return getLineWidthFunctionMapping.default_line(v);
        return 1;
      },

      pointType: customSqlFifthLayer.pointType ? customSqlFifthLayer.pointType : 'circle',

      onDataLoad: (data) => {
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object && info?.object?.properties) {
          const tooltip = customSqlData[4]?.properties?.tooltip;
          const title = tooltip?.title ? tooltip?.title : 'Details';
          let subTitle = tooltip?.subtitle ? tooltip?.subtitle : '';
          let htmlString = '';
          if (tooltip?.columns && tooltip?.columns?.length > 0) {
            if (
              tooltip.subtitle_column &&
              info?.object?.properties[tooltip.subtitle_column]
            ) {
              subTitle = info?.object?.properties[tooltip.subtitle_column];
            }
            htmlString += `<div class="deck-tooltip-title">${title}</div>`;
            if (subTitle) {
              htmlString += `<div class="deck-tooltip-subtitle">${subTitle}</div>`;
            }
            htmlString += `<div class="deck-hr"></div><div class="deck-tooltip-msg-container">`;
            tooltip.columns.forEach((column) => {
              htmlString += `<div class="deck-tooltip-msg-wrapper"><div class="deck-tooltip-msg-text-1">${
                getNameFormatterFromColumn(source?.data, column)
                  ? getNameFormatterFromColumn(source?.data, column)
                  : column.replace(/_/g, ' ')
              }</div><div class="deck-tooltip-msg-text-2">`;
              htmlString += getValueFormatterFromColumn(source?.data, column)
                ? new Function(
                    'return ' + getValueFormatterFromColumn(source?.data, column)
                  )()(info?.object?.properties[column])
                : getFormattedValue(info?.object?.properties[column]);
              htmlString += `</div></div>`;
            });
            htmlString += `</div>`;
          }
          info.object = { html: htmlString };
        }
      },
    });
  }
}

export default CustomSqlFifthLayer;
